// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type UpdateEpmMasterVddMutationVariables = Types.Exact<{
  input: Types.UpdateEpmMasterVddInput;
}>;

export type UpdateEpmMasterVddMutation = { __typename?: 'Mutation' } & {
  updateEpmMasterVdd: { __typename?: 'EpmMasterVddOutput' } & Pick<Types.EpmMasterVddOutput, 'id'>;
};

export const UpdateEpmMasterVddDocument = /*#__PURE__*/ gql`
    mutation updateEpmMasterVdd($input: UpdateEpmMasterVddInput!) {
  updateEpmMasterVdd(input: $input) {
    id
  }
}
    `;
export type UpdateEpmMasterVddMutationFn = Apollo.MutationFunction<
  UpdateEpmMasterVddMutation,
  UpdateEpmMasterVddMutationVariables
>;

/**
 * __useUpdateEpmMasterVddMutation__
 *
 * To run a mutation, you first call `useUpdateEpmMasterVddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpmMasterVddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpmMasterVddMutation, { data, loading, error }] = useUpdateEpmMasterVddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEpmMasterVddMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateEpmMasterVddMutation, UpdateEpmMasterVddMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEpmMasterVddMutation, UpdateEpmMasterVddMutationVariables>(
    UpdateEpmMasterVddDocument,
    options,
  );
}
export type UpdateEpmMasterVddMutationHookResult = ReturnType<typeof useUpdateEpmMasterVddMutation>;
export type UpdateEpmMasterVddMutationOptions = Apollo.BaseMutationOptions<
  UpdateEpmMasterVddMutation,
  UpdateEpmMasterVddMutationVariables
>;
